import { render, staticRenderFns } from "./addAccountDialog.vue?vue&type=template&id=dbb99620&scoped=true"
import script from "./addAccountDialog.vue?vue&type=script&lang=js"
export * from "./addAccountDialog.vue?vue&type=script&lang=js"
import style0 from "./addAccountDialog.vue?vue&type=style&index=0&id=dbb99620&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb99620",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbb99620')) {
      api.createRecord('dbb99620', component.options)
    } else {
      api.reload('dbb99620', component.options)
    }
    module.hot.accept("./addAccountDialog.vue?vue&type=template&id=dbb99620&scoped=true", function () {
      api.rerender('dbb99620', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/email/components/addAccountDialog.vue"
export default component.exports